import { render, staticRenderFns } from "./VasionDocumentTemplateIconLarge.svg?vue&type=template&id=f8454a58"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports